import './ui/scss/style.scss';

import { main } from './main';

main();
